import axios from "axios";
import { filterRecords } from "utils/common";
import { setPrompt } from "../prompt";
import { trackEvent } from "utils/analytics";
export const GET_ADMIN_CLIENTS_DATA = "get_admin_clients_data";

export const getAdminClients = () => {
  return (dispatch) => {
    dispatch(loadingClients(true));
    axios
      .get("api/admin/owner")
      .then((res) => {
        // Sort the data by created_on in descending order
        const sortedData = [...res.data.data].sort((a, b) => {
          return new Date(b.created_on) - new Date(a.created_on);
        });
        dispatch({
          type: GET_ADMIN_CLIENTS_DATA,
          payload: sortedData,
        });
        dispatch(loadingClients(false));
      })
      .catch(() => {
        dispatch({
          type: GET_ADMIN_CLIENTS_DATA,
          payload: [],
        });
        dispatch(loadingClients(false));
      });
  };
};

export const PAGINATION_CLIENTS_DATA = "pagination_clients_data";
export const changePagination = (response = 1) => {
  return (dispatch) => {
    dispatch({
      type: PAGINATION_CLIENTS_DATA,
      payload: response,
    });
  };
};

export const SEARCH_CLIENTS_DATA = "search_clients_data";
export const searchClients = (search = "", filters = [], subscriptionFilters = []) => {
  return (dispatch, getState) => {
    let filteredItem = (getState().admin.clients.searchedClients || []).filter(
      (e) => {
        const firstName = e.first_name?.toLowerCase() || "";
        const lastName = e.last_name?.toLowerCase() || "";
        const email = e.email?.toLowerCase() || "";
        return (
          firstName.includes(search.toLowerCase()) ||
          lastName.includes(search.toLowerCase()) ||
          email.includes(search.toLowerCase())
        );
      }
    );
    filteredItem = filterRecords(filteredItem, "", filters, "status");
    if (subscriptionFilters.length > 0) {
      filteredItem = filteredItem.filter((e) =>
        subscriptionFilters.includes(e.organization?.subscription?.name)
      );
    }
    dispatch({
      type: SEARCH_CLIENTS_DATA,
      payload: filteredItem,
    });
  };
};

export const LOADING_ADMIN_CLIENTS_DATA = "loading_admin_clients_data";

export const loadingClients = (response = false) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_ADMIN_CLIENTS_DATA,
      payload: response,
    });
  };
};

export const deleteClientById = (id = "", toggleDeleteModal) => {
  return (dispatch) => {
    return axios
      .delete(`/api/coach/users/${id}`)
      .then(() => {
        dispatch(getAdminClients());
      })
      .catch((err) => {
        toggleDeleteModal();
      });
  };
};

export const GET_OWNER_STATS = "get_owner_stats";
export const GET_OWNER_STATS_SUCCESS = "get_owner_stats_success";
export const GET_OWNER_STATS_FAILURE = "get_owner_stats_failure";

export const getOwnerStats = (orgId) => {
  return (dispatch) => {
    dispatch({ type: GET_OWNER_STATS });
    return axios
      .get(`/api/admin/owner/${orgId}/stats`)
      .then((res) => {
        dispatch({ type: GET_OWNER_STATS_SUCCESS, payload: res.data.data });
      })
      .catch((err) => {
        dispatch({ type: GET_OWNER_STATS_FAILURE });
      });
  };
};

export const inviteOwnerHandler = (data, toggleInviteClientModal) => {
  return (dispatch) => {
    return axios
      .post(`/api/admin/invite/owner`, data)
      .then(() => {
        trackEvent('Admin', 'owner_invited');
        dispatch(getAdminClients());
        toggleInviteClientModal();
      })
      .catch((err) => {
        toggleInviteClientModal();
        dispatch(
          setPrompt({
            isOpen: true,
            message: err?.response?.data?.message,
            hidePrimaryBtn: true,
          })
        );
      });
  };
};
